import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=d73815fe"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports